import Layout from '@/layout'

const userManageRouter = {
  path: '/user-manage',
  component: Layout,
  redirect: '/user-manage/user-list',
  name: 'UserManage',
  meta: {
    title: 'userManage',
    icon: 'people'
  },
  children: [
    {
      path: 'user-list',
      component: () => import('@/views/user-manage/user/list'),
      name: 'UserList',
      meta: { title: 'userList', noCache: false }
    },
    {
      path: 'copyright-watch-review',
      component: () => import('@/views/user-manage/copyright-watch-review/index.vue'),
      name: 'CopyrightWatchReview',
      meta: { title: 'copyrightWatchReview', noCache: false }
    },
    {
      path: 'copyright-watch-review/detail',
      component: () => import('@/views/user-manage/copyright-watch-review/detail.vue'),
      name: 'CopyrightWatchReviewDetail',
      hidden: true,
      meta: {
        title: 'copyrightWatchReviewDetail',
        noCache: true,
        activeMenu: '/user-manage/copyright-watch-review'
      }
    },
    {
      path: 'user-black-list',
      component: () => import('@/views/user-manage/black-list/index'),
      name: 'UserBlackList',
      meta: { title: 'userBlackList', noCache: false }
    },
    {
      path: 'user-super-white-list',
      component: () => import('@/views/user-manage/super-white-list/index'),
      name: 'UserSuperWhiteList',
      meta: { title: 'userSuperWhiteList', noCache: false }
    },
    {
      path: 'user-label',
      component: () => import('@/views/user-manage/user-label/index'),
      name: 'UserLabel',
      meta: { title: 'userLabel', noCache: false }
    },
    {
      path: 'white-list',
      component: () => import('@/views/user-manage/white-list/index'),
      name: 'WhiteList',
      meta: { title: 'whiteList', noCache: false }
    },
    {
      path: 'user-indicator',
      component: () => import('@/views/user-manage/user-indicator/index'),
      name: 'Indicator',
      meta: { title: 'Indicator', noCache: false }
    },
    {
      path: 'user-indicator',
      component: () => import('@/views/user-manage/user-indicator/index'),
      name: 'Indicator',
      meta: { title: 'Indicator', noCache: false }
    },
    {
      path: 'user-labelSystem',
      component: () => import('@/views/user-manage/labelSystem/index'),
      name: 'LabelSystem',
      meta: { title: 'LabelSystem', noCache: false }
    },
    {
      path: 'label-add',
      component: () => import('@/views/user-manage/labelSystem/old/add/index.vue'),
      name: 'LabelAddOld',
      meta: { title: 'LabelAdd', noCache: true }
    },
    {
      path: 'label-add-new',
      component: () => import('@/views/user-manage/labelSystem/new/add/index.vue'),
      name: 'LabelAddNew',
      meta: { title: 'LabelAdd', noCache: true }
    },
    {
      path: 'id-search',
      component: () => import('@/views/user-manage/id-search/index.vue'),
      name: 'IdSearch',
      meta: { title: 'IdSearch', noCache: true }
    },
    {
      path: 'tag-selection',
      component: () => import('@/views/user-manage/tag-selection/index.vue'),
      name: 'TagSelection',
      meta: { title: 'TagSelection', noCache: false }
    },
    {
      path: 'tag-selection-add',
      component: () => import('@/views/user-manage/tag-selection/add/index.vue'),
      name: 'TagSelectionAdd',
      meta: { title: 'TagSelectionAdd', noCache: true }
    },
    {
      path: 'tag-selection-add/ab',
      component: () => import('@/views/user-manage/tag-selection/ab/add.vue'),
      name: 'TagSelectionAdd',
      meta: { title: 'TagSelectionAdd', noCache: true }
    }
  ]
}

export default userManageRouter
